import React, { useEffect } from 'react';

import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { MatchPreviewResponse } from '@/feature/fantasy-event-sheets/hooks/use-match-preview';
import { League } from '@/types/api.generated';

export const FantasyMatchPreview = ({
    matchPreview,
    league,
}: {
    matchPreview?: MatchPreviewResponse;
    league: League;
}) => {
    const noPreview = !matchPreview || (!matchPreview.headline && matchPreview.items.length === 0);

    useEffect(() => {
        if (!noPreview) {
            BetrAnalytics.trackEvent(AnalyticsEvent.FANTASY_MATCH_PREVIEW_SHOWN, { league: league });
        }
    }, [league, noPreview]);

    if (noPreview) {
        return null;
    }

    return (
        <Box py={'s24'} px={'s16'} zIndex={-1}>
            <Text variant={'titleMedium'} color={ds.colorToken.text.primary} mb={'s6'}>
                {matchPreview.headline}
            </Text>
            {matchPreview.items.map((item, index) => (
                <Text key={`preview-item-${index}`} variant={'bodyMedium'} color={ds.colorToken.text.secondary} mt="s6">
                    {item}
                </Text>
            ))}
            <Box mt={'s24'} gap={'s8'} flexDirection={'row'} alignItems={'center'}>
                <Box flex={1} height={1} backgroundColor={ds.colorToken.background.neutral.subtler} />
                <Box
                    p={'s8'}
                    borderRadius={'r10'}
                    borderWidth={1}
                    borderColor={ds.colorToken.background.neutral.subtler}
                >
                    <Text variant={'bodySmaller'} color={'neutral400'} lineHeight={12}>
                        AI-generated preview. May contain inaccuracies.
                    </Text>
                </Box>
                <Box flex={1} height={1} backgroundColor={ds.colorToken.background.neutral.subtler} />
            </Box>
        </Box>
    );
};
